if (window.location.pathname == '/my-account') {
    $('.deletePicture').click(function () {
        $('form .card-body .img-fluid').attr('src', noPicture);
        $('#updateForm .deletePictureDiv').html('<input type="hidden" name="hidden" value="empty" />');
    })
    $(document).ready(function () {
        googleMaps();

        var hash = '';
        $('#pills-tab a').click(function () {
            hash = $(this).attr('href');
            window.location.hash = $(this).attr('href');
        });

        if (saveSuccess) {
            $('#pills-profile-tab').click();
        }

        if (stripeErrors) {
            $('#pills-profile-tab').click();
        }
    });

    $(document).ready(function () {
        var elements = stripe.elements();
        var style = {
            base: {
                color: '#32325d',
                lineHeight: '18px',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                },
                lineHeight: '1.429'
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };
        var cardStripe = elements.create('card', {
            style: style,
            hidePostalCode: true,
        });
        cardStripe.mount('#card-element');
        cardStripe.addEventListener('change', function (event) {
            var displayError = document.getElementById('card-errors');
            if (event.error) {
                displayError.textContent = event.error.message;
                $('#submitBtn').prop('disabled', true);
                $('#card-errors').addClass('alert alert-danger');
            } else {
                displayError.textContent = '';
                $('#submitBtn').prop('disabled', false);
                $('#card-errors').removeClass('alert alert-danger');
            }
        });

        _beforeSubmit = function (e) {
            var button = $(e.srcElement).find('button');
            text = button.html();

            button.prop('disabled', true);
            button.html('<i class="fas fa-circle-notch fa-spin"></i>');

            let iframe = document.querySelector(
                'iframe[src^="https://www.google.com/recaptcha"][src*="bframe"]');

            let container = iframe.parentNode.parentNode;
            let observer = new MutationObserver(mutations => {
                if (container && container.style.visibility === 'hidden') {
                    //button.prop('disabled', false);
                    //button.html(text);
                }
            });

            observer.observe(container, {
                attributes: true,
                attributeFilter: ['style']
            });

            var $form = $('#save-form');

            try {
                var card_name = document.getElementById('name').value;
                stripe.createPaymentMethod('card', cardStripe, {
                    billing_details: {
                        name: card_name
                    }
                }).then(function (result) {

                    if (result.error) {
                        var errorElement = document.getElementById('card-errors');
                        errorElement.textContent = result.error.message;
                        button.prop('disabled', false);
                        button.html(text);
                        return false;
                    } else {

                        $form.append($('<input type="hidden" name="stripeToken" />').val(result
                            .paymentMethod.id));
                        if (grecaptcha.getResponse() != '') {
                            grecaptcha.reset();
                        }
                        grecaptcha.execute();
                        return true;
                    }
                });
            } catch (error) {
                console.log(error);
                return false;
            }
        }

        $('#submtBtn').click(function () {
            $('#save-form').submit();
        });

        var hashUrl = window.location.hash;
        $("ul#pills-tab a[href='" + hashUrl + "']").click();

    });
}